<div class="dep-field">

  <ng-container *ngIf="_value else depButtons">
    <div class="data-selected" >
      <mat-icon (click)="openSelectModal()">edit_note</mat-icon>
      <span (click)="openSelectModal()">
      {{displayValue}}
    </span>
      <mat-icon (click)="deleteSelectedItem()">close</mat-icon>
    </div>
  </ng-container>

  <ng-template #depButtons>
    <div class="create-btn" [class.hidden]="disableFormBtn" [class.locked]="lockSelectBtn" [class.one-btn]="disableSelectBtn" (click)="openCreateModal()">
      <mat-icon>add</mat-icon>
      <span>{{'formGenerator.fields.depField.btnCreer' | translate}}</span>
    </div>
    <div class="select-btn" [class.hidden]="disableSelectBtn" [class.locked]="lockSelectBtn" [class.one-btn]="disableFormBtn" (click)="openSelectModal()">
      <mat-icon>manage_search</mat-icon>
      <span>{{'formGenerator.fields.depField.btnRechercher' | translate}}</span>
    </div>
  </ng-template>

  <ng-template #loading>
    <div class="loader">
      <ion-spinner name="crescent"></ion-spinner>
    </div>
  </ng-template>
</div>
